package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AssigneesRequest(
    @SerialName("employees") var employees: List<String?>? = null,
    @SerialName("teams") var teams: List<String?>? = null,
)